import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-21.738135, 166.177644, 13],
  [-21.738047, 166.177826, 13],
  [-21.737958, 166.17803, 13],
  [-21.737873, 166.178212, 13],
  [-21.737794, 166.178405, 13],
  [-21.737714, 166.178609, 13],
  [-21.737628, 166.178792, 13],
  [-21.737539, 166.178985, 13],
  [-21.737453, 166.179178, 13],
  [-21.73737, 166.17936, 13],
  [-21.737288, 166.179553, 13],
  [-21.737216, 166.179757, 13],
  [-21.737148, 166.17995, 13],
  [-21.737074, 166.180154, 13],
  [-21.737001, 166.180347, 13],
  [-21.736933, 166.180551, 13],
  [-21.736859, 166.180744, 13],
  [-21.736787, 166.180948, 13],
  [-21.736714, 166.18113, 13],
  [-21.736642, 166.181324, 13],
];

export default stream;
